var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app-bar",
    { attrs: { dark: "" } },
    [
      _vm._v(" Consultation des VL Casino "),
      _c("v-spacer"),
      _vm._v(
        " " +
          _vm._s(
            _vm.code + " - " + _vm.currentCompany + " - " + _vm.currentWarehouse
          ) +
          " "
      ),
      _c(
        "v-btn",
        {
          attrs: { fab: "", app: "", text: "" },
          on: { click: _vm.handleLogout }
        },
        [_c("v-icon", { attrs: { large: "" } }, [_vm._v("mdi-logout")])],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }